import axios from  "axios";

export const axiosInstance = axios.create({
    baseURL : "https://blog-qe7s.onrender.com/api/"
})